export default "__VITE_ASSET__THbmzKlu__"